/* src/app/components/shop/products/product-dialog/product-dialog.component.scss */
.img-parent {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-height: 290px;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 100%;
  border-bottom: 1px solid #ddd;
}
.img-parent img {
  height: auto;
  max-height: 290px;
  max-width: 100%;
}
::ng-deep .product-dialog .close-button {
  float: right;
  top: -52px;
  right: -52px;
}
::ng-deep .product-dialog .mat-mdc-dialog-container {
  margin: 20px 0px;
  overflow: unset;
}
/*# sourceMappingURL=product-dialog.component.css.map */
